import { render, staticRenderFns } from "./ManagementDashboard.vue?vue&type=template&id=3937a14a&scoped=true&"
import script from "./ManagementDashboard.vue?vue&type=script&lang=js&"
export * from "./ManagementDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ManagementDashboard.vue?vue&type=style&index=0&id=3937a14a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3937a14a",
  null
  
)

component.options.__file = "ManagementDashboard.vue"
export default component.exports